// Fallback for non-secure contexts (HTTP) where crypto.randomUUID is unavailable
function generateUUID() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  // Fallback using crypto.getRandomValues (available in all modern browsers)
  return '10000000-1000-4000-8000-100000000000'.replace(/[018]/g, (c) =>
    (+c ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (+c / 4)))).toString(16),
  );
}

// State management
export const state = {
  allDocChunks: [],
  currentTab: 'documentation',
  semanticSearchEnabled: false,
  currentCollection: 'user_faq',
  availableCollections: [],
  availableDocuments: [],
  selectedDocuments: [],
  chatHistory: [],
  sessionId: generateUUID(),
};

// Auth state (separate from main state for localStorage persistence)
const AUTH_STORAGE_KEY = 'biv_auth_state';

let authState = {
  token: null,
  username: null,
  isAuthenticated: false,
};

// Load auth state from localStorage
export function loadAuthState() {
  try {
    const stored = localStorage.getItem(AUTH_STORAGE_KEY);
    if (stored) {
      authState = JSON.parse(stored);
    }
  } catch (error) {
    console.error('Failed to load auth state:', error);
  }
  return authState;
}

// Save auth state to localStorage
export function saveAuthState() {
  try {
    localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(authState));
  } catch (error) {
    console.error('Failed to save auth state:', error);
  }
}

// Update auth state
export function updateAuthState(updates) {
  Object.assign(authState, updates);
  saveAuthState();
}

// Get auth state
export function getAuthState() {
  return authState;
}

// Get auth token
export function getAuthToken() {
  return authState.token;
}

// Decode the role out of the JWT payload (not verified — display/UI-gating only,
// actual authorization is always re-checked server-side).
export function getUserRole() {
  const token = authState.token;
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.role || null;
  } catch {
    return null;
  }
}

export function updateState(updates) {
  Object.assign(state, updates);
}

export function resetSession() {
  state.sessionId = generateUUID();
}

// Initialize auth state on load
loadAuthState();
